module.exports = __webpack_public_path__ + "static/media/short_description_icon.f911214c.svg";